import { AuthEffects } from './auth.effects';
import { RewardEffects } from './reward.effects';
import { RolesEffects } from './roles.effects';
import { StoresEffects } from './stores.effects';
import { SuppliersEffects } from './supplier.effects';
import { LabelsEffects } from './label.effects';
import { UserEffects } from './user.effects';

export const EffectsArray: any[] = [
  AuthEffects,
  RewardEffects,
  RolesEffects,
  StoresEffects,
  SuppliersEffects,
  LabelsEffects,
  UserEffects
];
